'use strict';

module.exports = {};
module.exports.Arc = require('./element.arc');
module.exports.Line = require('./element.line');
module.exports.Point = require('./element.point');
module.exports.Rectangle = require('./element.rectangle');



//////////////////
// WEBPACK FOOTER
// /codebuild/output/src946329470/src/frontend/~/chart.js/src/elements/index.js
// module id = ../../../../chart.js/src/elements/index.js
// module chunks = 4